export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/white_background.cb7b0ae.svg";